export default __webpack_public_path__ + "images/nvent-brand-erico.png?5519d4eaa3a0fb79969b38163192cad4";